const SNACKBAR_SHOW = 'SNACKBAR_SHOW'
const SNACKBAR_DISPOSE = 'SNACKBAR_DISPOSE'

export { SNACKBAR_SHOW, SNACKBAR_DISPOSE }
